export const PAYPAL = "PAYPAL";
export const BANK_TRANSFER = "BANK_TRANSFER";
